import React, { useState } from 'react';

const logoPath = `${process.env.PUBLIC_URL || ''}/app_logo_clean.png`;

function FallbackLogo() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18" />
      <path d="M5 21V8l7-5 7 5v13" />
      <path d="M9 21v-6h6v6" />
    </svg>
  );
}

function AppLogo({ className = 'brand-mark', alt = '' }) {
  const [failed, setFailed] = useState(false);

  return (
    <span className={`${className} ${failed ? 'logo-fallback' : ''}`}>
      {failed ? (
        <FallbackLogo />
      ) : (
        <img src={logoPath} alt={alt} onError={() => setFailed(true)} />
      )}
    </span>
  );
}

export default AppLogo;
